module.exports = __webpack_public_path__ + "static/media/41 - Claudia Barry - Love for the Sake of Love.40372d00.mp3";